import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useRequireLogin from '../../hooks/useRequireLogin';
// Components
import Row from '../../components/shared/atoms/Row';
import Box from '../../components/shared/atoms/Box';
import Separator from '../../components/Separator';
import Container from '../../components/shared/atoms/Container';
import Heading from '../../components/shared/atoms/Heading';
import AccountNav from '../../components/customerArea/shared/AccountNav';
import DisplayBillingAddresses from '../../components/customerArea/BillingAddresses/DisplayBillingAddresses';
import AddBillingAddress from '../../components/customerArea/BillingAddresses/AddBillingAddress';

const BillingAddresses = () => {
  const { t } = useTranslation();
  const { client } = useSelector((s) => s);
  // Bumped after any create/edit/delete/set-default so the list re-fetches and
  // reflects the server-computed default (never recomputed client-side).
  const [refresh, setRefresh] = useState(0);
  const bumpRefresh = () => setRefresh((n) => n + 1);
  const isLoggedIn = useRequireLogin();

  if (!isLoggedIn) {
    return null;
  }

  return (
    <Container>
      <Container fluid pb={10} pt={4}>
        <Helmet title={t('billingaddresses.meta.title')} />
        <Row md gap={56}>
          <AccountNav />
          <Box>
            <Heading level={2} mb={6}>
              {t('billingaddresses.headings.1')}
            </Heading>
            <DisplayBillingAddresses
              client={client}
              refresh={refresh}
              onChanged={bumpRefresh}
            />
            <Separator axe="horizontal" bg="gray.light" margin="24px 0px" />
            <AddBillingAddress clientId={client.id} onAdded={bumpRefresh} />
          </Box>
        </Row>
      </Container>
    </Container>
  );
};

export default BillingAddresses;
